import {
    AccountBalance as BankIcon,
    BarChart as BarChartIcon,
    Dashboard as DashboardIcon,
    Description as FileTextIcon,
    DesktopWindows as WorkstationIcon,
    Stars as GoldIcon,
    Logout as LogoutIcon,
    Monitor as MonitorIcon,
    Settings as SettingsIcon,
    Store as ShopIcon,
    Person as UserIcon,
    PointOfSale as CashIcon,
    SwapHoriz as SwapHorizIcon,
    Assessment as AssessmentIcon,
    Build as BuildIcon,
    Handyman as HandymanIcon,
    Payments as PaymentsIcon,
    Undo as UndoIcon,
    SwitchAccount as SwitchUserIcon,
    ReceiptLong as ReceiptIcon,
} from '@mui/icons-material';
import type { ReactNode } from 'react';

const iconMap: Record<string, ReactNode> = {
    dashboard: <DashboardIcon />,
    clients: <UserIcon />,
    contracts: <FileTextIcon />,
    inventory: <ShopIcon />,
    reports: <BarChartIcon />,
    rapoarte: <AssessmentIcon />,
    contabilitate: <BankIcon />,
    settings: <SettingsIcon />,
    metals: <GoldIcon />,
    'control-room': <MonitorIcon />,
    logout: <LogoutIcon />,
    pred_casa: <CashIcon />,
    'inventory-movement': <SwapHorizIcon />,
    statistics: <AssessmentIcon />,
    configuration: <BuildIcon />,
    'hardware-service': <WorkstationIcon />,
    advanced: <HandymanIcon />,
    salary: <PaymentsIcon />,
    frmlistari: <FileTextIcon />,
    regiszter: <FileTextIcon />,
    frmverifylastsession: <CashIcon />,
    frmstorno: <UndoIcon />,
    schutil: <SwitchUserIcon />,
    'e-invoice': <ReceiptIcon />,
};

/** The icon of a menu entry, by its page key; a generic one for an entry that has none. */
export const menuIconFor = (pageKey: string): ReactNode => iconMap[pageKey] ?? <DashboardIcon />;
